import { render, staticRenderFns } from "./Databases.vue?vue&type=template&id=de0d7d26&scoped=true&"
import script from "./Databases.vue?vue&type=script&lang=js&"
export * from "./Databases.vue?vue&type=script&lang=js&"
import style0 from "./Databases.vue?vue&type=style&index=0&id=de0d7d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0d7d26",
  null
  
)

export default component.exports